var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFidelidadeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#A51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460 939 c-118 -19 -245 -106 -307 -211 -18 -29 -41 -87 -52 -128 -18 -72 -20 -75 -50 -78 -17 -2 -31 -6 -31 -9 0 -15 96 -172 104 -170 5 2 31 41 58 88 l48 84 -33 5 c-30 5 -32 7 -29 40 9 99 102 219 211 273 60 29 74 32 161 32 82 0 103 -4 152 -27 80 -37 152 -107 191 -187 29 -60 32 -74 32 -161 0 -82 -4 -103 -26 -150 -38 -82 -109 -154 -187 -192 -61 -30 -74 -33 -162 -33 -108 1 -161 19 -237 81 -52 42 -86 43 -91 2 -3 -23 6 -34 57 -72 187 -137 460 -110 611 62 237 269 84 695 -270 751 -73 12 -74 12 -150 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 750 c0 -24 -7 -33 -39 -50 -53 -27 -71 -55 -71 -111 0 -65 30 -98 119 -134 85 -34 107 -54 91 -84 -14 -26 -86 -29 -132 -5 -43 22 -81 6 -76 -34 2 -22 13 -32 55 -52 45 -21 53 -29 53 -52 0 -25 3 -28 35 -28 32 0 35 3 35 28 0 24 7 31 49 49 61 25 86 62 86 124 0 63 -24 87 -131 135 -77 34 -85 40 -82 63 3 23 8 26 47 29 23 2 57 -2 74 -8 26 -9 34 -7 50 9 26 25 15 56 -26 71 -54 20 -62 26 -65 54 -3 22 -8 26 -38 26 -31 0 -34 -3 -34 -30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFidelidadeActive);
export default __webpack_public_path__ + "static/media/icon_fidelidade_active.13cffcd5060c338468e2ae4616cc371a.svg";
export { ForwardRef as ReactComponent };